import { render, staticRenderFns } from "./ApartmentTest.vue?vue&type=template&id=0454570d"
import script from "./ApartmentTest.vue?vue&type=script&lang=js"
export * from "./ApartmentTest.vue?vue&type=script&lang=js"
import style0 from "./ApartmentTest.vue?vue&type=style&index=0&id=0454570d&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports